<template>
	<div class="congrate-container">
		<v-img class="image mb-4" src="@/assets/images/goToReport/end-formation.png"></v-img>
		<div>
			<h2 class="ortho-results-title mb-1">Félicitations, tu viens de terminer ta formation</h2>
			<p class="ortho-description ortho-text-gray">Découvre ta performance</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CongrateFinishFormation',
	props: {
		parcours: Object,
	},
};
</script>

<style lang="scss" scoped>
.congrate-container {
	text-align: center;
	border-radius: 8px;
	padding: 0.5rem 0.2rem;
	background-color: white;

	.image {
		margin: 0 auto;
		width: 170px;
		@media screen and (max-width: 960px) {
			width: 130px;
		}
	}
	.parcours-name {
		text-transform: capitalize;
	}
}
</style>
